import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m6 15.5 2 2 4.5-4.5M8 8.5V5.7c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C9.52 2.5 10.08 2.5 11.2 2.5h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 4.02 22 4.58 22 5.7v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H16m-10.8 6h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 20.98 16 20.42 16 19.3v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 8.5 13.92 8.5 12.8 8.5H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 10.02 2 10.58 2 11.7v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218"
    }, null, -1)
  ])))
}
export default { render: render }